module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/215-falkland-islands-71637b261a04b8014c1298b4d76b2c46.svg";